import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core'
import { NotBlankGenericFieldValidator } from '../../../validations/not-blank-generic-field-validator'
import { DateTextFieldValidator } from '../../../validations/date-text-field.validator'
import { ValidatedRadioButtonModel } from '../../../validations/validated-radio-button-group.component'
import { PrescriptionStep2 } from '../../models/prescription-step2'
import { OtherDrugCoverage } from '../../models/enrollments'
import { NumericTextFieldValidator } from '../../../validations/numeric-text-field-validator'
import { EnrollmentViewModel } from '../../models/enrollment-view-model'
import { EnrollmentGateway } from '../../gateways/enrollment-gateway'
import { PortalGlobals } from '../../../portalglobals'
import { CurrentUserGateway } from '../../../common/gateways/current-user-gateway'
// import { AlphaNumericIncludesSpaceCheckFieldValidator } from '../../../validations/alpha-numeric-field-validator'

@Component({

    templateUrl: 'prescripition-drug-component.html',
    selector: 'prescripitionDrug'

})

export class PrescriptionDrug implements OnInit {
    @Input() disabled: boolean = false
    @Input() isExternalAgentEnrl: boolean
    @Input() showOtherCoverage: boolean = false
    @Input() enrollment: EnrollmentViewModel = new EnrollmentViewModel()
    @Output() onValueChange: EventEmitter<any> = new EventEmitter<any>()
   // alphanumericincludespacechecksValidator: AlphaNumericIncludesSpaceCheckFieldValidator = new AlphaNumericIncludesSpaceCheckFieldValidator()
    notBlankValidator = new NotBlankGenericFieldValidator()
    numericValidator = new NumericTextFieldValidator()
    validatedDate = new DateTextFieldValidator()
    isValidAgent: boolean
    isFormValid: boolean
    selFaxContactType: string
    dateofReceiptInvalid: boolean
    ContactTypeInvalid: boolean
    electionperiod: string
    showDet = false
    selPresDrug: string
    optionrbPresDrug: ValidatedRadioButtonModel[] = []
    optionrbLang: ValidatedRadioButtonModel[] = []
    disableLang: boolean
    orgName: string
    visibleFrom2025: boolean
    visibleFrom2026: boolean
    PDPlan:string

    constructor(private _enrollService: EnrollmentGateway, public _global: PortalGlobals, private _currentUserGateway: CurrentUserGateway) {
        this.optionrbPresDrug.push({ value: 'yes', htmlLabel: 'Yes' }, { value: 'no', htmlLabel: 'No' })
        this.optionrbLang.push({ value: 'English', htmlLabel: 'English' }, { value: 'Spanish', htmlLabel: 'Spanish' }, { value: 'Other', htmlLabel: 'Other' })
    }

    ngOnInit() {
        if (this._global.currentUser === undefined) {
            this._currentUserGateway.getCurrentUser()
                .subscribe(user => {
                    if (user != null) {
                        this._global.currentUser = user
                        this.SetPageData()
                    }
                })
        }
        else {
            this.SetPageData()
        }

    }
    toggle(event: any, fieldName: string) {
        if (event === 'yes') {
            this.showDet = true
            this.showOtherCoverage = true
        } else {
            this.showDet = false
            this.showOtherCoverage = false
        }
        this.updateInfo(fieldName, event)
    }

    updateInfo(fieldName: string, fieldValue: string) {
        this.enrollment[fieldName] = fieldValue
        this.onValueChange.emit(this.enrollment)
    }

    private SetPageData() {
        this.enrollment = this._enrollService.getEnrollmentViewModel()
        this.toggle(this.enrollment.OTHCVRG, 'OTHCVRG')

        if (this._global.selectedPlanYear > this._global.Planyear2024) {
            this.visibleFrom2025 = true;
        }
        if (this._global.selectedPlanYear > this._global.Planyear2025) {
            this.visibleFrom2026 = true;
        }

        this.setOrgname(this.enrollment.ISSINGLEGROUP)
    }
    private setOrgname(ISSINGLEGROUP: boolean) {
        if (ISSINGLEGROUP === true) {
            this.orgName = this._global.currentUser.insuranceCompanyName
        }
        else {
            if (this._global.selectedPlanYear === 0 || this._global.selectedPlanYear === undefined) {
                if (sessionStorage.getItem("PLANYEAR") !== undefined) {
                    this._global.selectedPlanYear = Number(sessionStorage.getItem("PLANYEAR"))
                }
            }
            if (Number(this._global.selectedPlanYear) === this._global.CurrentYear) {
                this.orgName = this._global.currentUser.insuranceCompanyName
            }
            else {
                this.orgName = this._global.insuranceCompanyNameAetna
            }
        }
    }
}
